import withIcon from './withIcon';

export const IcnPdsAll = withIcon(
    () => import('./svg/icn_pds_all.svg?component'),
);
export const IcnPdsApple = withIcon(
    () => import('./svg/icn_pds_apple.svg?component'),
);
export const IcnPdsArrowDown = withIcon(
    () => import('./svg/icn_pds_arrow_down.svg?component'),
);
export const IcnPdsArrowDownSolid = withIcon(
    () => import('./svg/icn_pds_arrow_down_solid.svg?component'),
);
export const IcnPdsArrowLeft = withIcon(
    () => import('./svg/icn_pds_arrow_left.svg?component'),
);
export const IcnPdsArrowRight = withIcon(
    () => import('./svg/icn_pds_arrow_right.svg?component'),
);
export const IcnPdsArrowUp = withIcon(
    () => import('./svg/icn_pds_arrow_up.svg?component'),
);
export const IcnPdsArrowUpSolid = withIcon(
    () => import('./svg/icn_pds_arrow_up_solid.svg?component'),
);
export const IcnPdsBack = withIcon(
    () => import('./svg/icn_pds_back.svg?component'),
);
export const IcnPdsBaggage = withIcon(
    () => import('./svg/icn_pds_baggage.svg?component'),
);
export const IcnPdsBed = withIcon(
    () => import('./svg/icn_pds_bed.svg?component'),
);
export const IcnPdsBellNormal = withIcon(
    () => import('./svg/icn_pds_bell_normal.svg?component'),
);
export const IcnPdsBellSolid = withIcon(
    () => import('./svg/icn_pds_bell_solid.svg?component'),
);
export const IcnPdsBooklist = withIcon(
    () => import('./svg/icn_pds_booklist.svg?component'),
);
export const IcnPdsBuilding = withIcon(
    () => import('./svg/icn_pds_building.svg?component'),
);
export const IcnPdsCalCheck = withIcon(
    () => import('./svg/icn_pds_cal_check.svg?component'),
);
export const IcnPdsCalendar = withIcon(
    () => import('./svg/icn_pds_calendar.svg?component'),
);
export const IcnPdsCall = withIcon(
    () => import('./svg/icn_pds_call.svg?component'),
);
export const IcnPdsCamera = withIcon(
    () => import('./svg/icn_pds_camera.svg?component'),
);
export const IcnPdsCancel = withIcon(
    () => import('./svg/icn_pds_cancel.svg?component'),
);
export const IcnPdsCar = withIcon(
    () => import('./svg/icn_pds_car.svg?component'),
);
export const IcnPdsChart = withIcon(
    () => import('./svg/icn_pds_chart.svg?component'),
);
export const IcnPdsCheck = withIcon(
    () => import('./svg/icn_pds_check.svg?component'),
);
export const IcnPdsCircle = withIcon(
    () => import('./svg/icn_pds_circle.svg?component'),
);
export const IcnPdsClose = withIcon(
    () => import('./svg/icn_pds_close.svg?component'),
);
export const IcnPdsCommission = withIcon(
    () => import('./svg/icn_pds_commission.svg?component'),
);
export const IcnPdsControl = withIcon(
    () => import('./svg/icn_pds_control.svg?component'),
);
export const IcnPdsCopy = withIcon(
    () => import('./svg/icn_pds_copy.svg?component'),
);
export const IcnPdsCoupon = withIcon(
    () => import('./svg/icn_pds_coupon.svg?component'),
);
export const IcnPdsCritical = withIcon(
    () => import('./svg/icn_pds_critical.svg?component'),
);
export const IcnPdsCrop = withIcon(
    () => import('./svg/icn_pds_crop.svg?component'),
);
export const IcnPdsDash = withIcon(
    () => import('./svg/icn_pds_dash.svg?component'),
);
export const IcnPdsDown = withIcon(
    () => import('./svg/icn_pds_down.svg?component'),
);
export const IcnPdsDownload = withIcon(
    () => import('./svg/icn_pds_download.svg?component'),
);
export const IcnPdsDropdown = withIcon(
    () => import('./svg/icn_pds_dropdown.svg?component'),
);
export const IcnPdsDropdownUp = withIcon(
    () => import('./svg/icn_pds_dropdownUp.svg?component'),
);
export const IcnPdsEdit = withIcon(
    () => import('./svg/icn_pds_edit.svg?component'),
);
export const IcnPdsEliteNormal = withIcon(
    () => import('./svg/icn_pds_elite_normal.svg?component'),
);
export const IcnPdsElitePlus = withIcon(
    () => import('./svg/icn_pds_elite_plus.svg?component'),
);
export const IcnPdsEmail = withIcon(
    () => import('./svg/icn_pds_email.svg?component'),
);
export const IcnPdsExitfullscreen = withIcon(
    () => import('./svg/icn_pds_exitfullscreen.svg?component'),
);
export const IcnPdsFacebook = withIcon(
    () => import('./svg/icn_pds_facebook.svg?component'),
);
export const IcnPdsFilter = withIcon(
    () => import('./svg/icn_pds_filter.svg?component'),
);
export const IcnPdsFirstpage = withIcon(
    () => import('./svg/icn_pds_firstpage.svg?component'),
);
export const IcnPdsFullscreen = withIcon(
    () => import('./svg/icn_pds_fullscreen.svg?component'),
);
export const IcnPdsGlobal = withIcon(
    () => import('./svg/icn_pds_global.svg?component'),
);
export const IcnPdsGps = withIcon(
    () => import('./svg/icn_pds_gps.svg?component'),
);
export const IcnPdsGuidebook = withIcon(
    () => import('./svg/icn_pds_guidebook.svg?component'),
);
export const IcnPdsHeadset = withIcon(
    () => import('./svg/icn_pds_headset.svg?component'),
);
export const IcnPdsHeartLine = withIcon(
    () => import('./svg/icn_pds_heart_line.svg?component'),
);
export const IcnPdsHeartSolid = withIcon(
    () => import('./svg/icn_pds_heart_solid.svg?component'),
);
export const IcnPdsHelp = withIcon(
    () => import('./svg/icn_pds_help.svg?component'),
);
export const IcnPdsHistory = withIcon(
    () => import('./svg/icn_pds_history.svg?component'),
);
export const IcnPdsHome = withIcon(
    () => import('./svg/icn_pds_home.svg?component'),
);
export const IcnPdsIncrease = withIcon(
    () => import('./svg/icn_pds_increase.svg?component'),
);
export const IcnPdsInfo = withIcon(
    () => import('./svg/icn_pds_info.svg?component'),
);
export const IcnPdsInsight = withIcon(
    () => import('./svg/icn_pds_insight.svg?component'),
);
export const IcnPdsKakao = withIcon(
    () => import('./svg/icn_pds_kakao.svg?component'),
);
export const IcnPdsLandmark = withIcon(
    () => import('./svg/icn_pds_landmark.svg?component'),
);
export const IcnPdsLastpage = withIcon(
    () => import('./svg/icn_pds_lastpage.svg?component'),
);
export const IcnPdsLight = withIcon(
    () => import('./svg/icn_pds_light.svg?component'),
);
export const IcnPdsLightning = withIcon(
    () => import('./svg/icn_pds_lightning.svg?component'),
);
export const IcnPdsLike = withIcon(
    () => import('./svg/icn_pds_like.svg?component'),
);
export const IcnPdsList = withIcon(
    () => import('./svg/icn_pds_list.svg?component'),
);
export const IcnPdsListIndicator = withIcon(
    () => import('./svg/icn_pds_listIndicator.svg?component'),
);
export const IcnPdsLocation = withIcon(
    () => import('./svg/icn_pds_location.svg?component'),
);
export const IcnPdsLock = withIcon(
    () => import('./svg/icn_pds_lock.svg?component'),
);
export const IcnPdsMap = withIcon(
    () => import('./svg/icn_pds_map.svg?component'),
);
export const IcnPdsMemo = withIcon(
    () => import('./svg/icn_pds_memo.svg?component'),
);
export const IcnPdsMenu = withIcon(
    () => import('./svg/icn_pds_menu.svg?component'),
);
export const IcnPdsMinus = withIcon(
    () => import('./svg/icn_pds_minus.svg?component'),
);
export const IcnPdsMore = withIcon(
    () => import('./svg/icn_pds_more.svg?component'),
);
export const IcnPdsMove = withIcon(
    () => import('./svg/icn_pds_move.svg?component'),
);
export const IcnPdsMultiCity = withIcon(
    () => import('./svg/icn_pds_multi_city.svg?component'),
);
export const IcnPdsNaver = withIcon(
    () => import('./svg/icn_pds_naver.svg?component'),
);
export const IcnPdsNearMe = withIcon(
    () => import('./svg/icn_pds_near_me.svg?component'),
);
export const IcnPdsNoPicture = withIcon(
    () => import('./svg/icn_pds_no_picture.svg?component'),
);
export const IcnPdsNoView = withIcon(
    () => import('./svg/icn_pds_no_view.svg?component'),
);
export const IcnPdsOneway = withIcon(
    () => import('./svg/icn_pds_oneway.svg?component'),
);
export const IcnPdsOutlink = withIcon(
    () => import('./svg/icn_pds_outlink.svg?component'),
);
export const IcnPdsParachute = withIcon(
    () => import('./svg/icn_pds_parachute.svg?component'),
);
export const IcnPdsParty = withIcon(
    () => import('./svg/icn_pds_party.svg?component'),
);
export const IcnPdsPerson = withIcon(
    () => import('./svg/icn_pds_person.svg?component'),
);
export const IcnPdsPicture = withIcon(
    () => import('./svg/icn_pds_picture.svg?component'),
);
export const IcnPdsPlus = withIcon(
    () => import('./svg/icn_pds_plus.svg?component'),
);
export const IcnPdsPoint = withIcon(
    () => import('./svg/icn_pds_point.svg?component'),
);
export const IcnPdsPrice = withIcon(
    () => import('./svg/icn_pds_price.svg?component'),
);
export const IcnPdsPrinter = withIcon(
    () => import('./svg/icn_pds_printer.svg?component'),
);
export const IcnPdsProhibition = withIcon(
    () => import('./svg/icn_pds_prohibition.svg?component'),
);
export const IcnPdsPromotion = withIcon(
    () => import('./svg/icn_pds_promotion.svg?component'),
);
export const IcnPdsRandom = withIcon(
    () => import('./svg/icn_pds_random.svg?component'),
);
export const IcnPdsRecord = withIcon(
    () => import('./svg/icn_pds_record.svg?component'),
);
export const IcnPdsRefresh = withIcon(
    () => import('./svg/icn_pds_refresh.svg?component'),
);
export const IcnPdsReply = withIcon(
    () => import('./svg/icn_pds_reply.svg?component'),
);
export const IcnPdsReservation = withIcon(
    () => import('./svg/icn_pds_reservation.svg?component'),
);
export const IcnPdsRestaurant = withIcon(
    () => import('./svg/icn_pds_restaurant.svg?component'),
);
export const IcnPdsReview = withIcon(
    () => import('./svg/icn_pds_review.svg?component'),
);
export const IcnPdsReviewLine = withIcon(
    () => import('./svg/icn_pds_review_line.svg?component'),
);
export const IcnPdsRocket = withIcon(
    () => import('./svg/icn_pds_rocket.svg?component'),
);
export const IcnPdsRotate = withIcon(
    () => import('./svg/icn_pds_rotate.svg?component'),
);
export const IcnPdsRoundtrip = withIcon(
    () => import('./svg/icn_pds_roundtrip.svg?component'),
);
export const IcnPdsSearch = withIcon(
    () => import('./svg/icn_pds_search.svg?component'),
);
export const IcnPdsSetting = withIcon(
    () => import('./svg/icn_pds_setting.svg?component'),
);
export const IcnPdsSettingLine = withIcon(
    () => import('./svg/icn_pds_setting_line.svg?component'),
);
export const IcnPdsShare = withIcon(
    () => import('./svg/icn_pds_share.svg?component'),
);
export const IcnPdsSparkling = withIcon(
    () => import('./svg/icn_pds_sparkling.svg?component'),
);
export const IcnPdsStar = withIcon(
    () => import('./svg/icn_pds_star.svg?component'),
);
export const IcnPdsStarHalf = withIcon(
    () => import('./svg/icn_pds_star_half.svg?component'),
);
export const IcnPdsStarHalfBg = withIcon(
    () => import('./svg/icn_pds_star_half_bg.svg?component'),
);
export const IcnPdsSubway = withIcon(
    () => import('./svg/icn_pds_subway.svg?component'),
);
export const IcnPdsSuccess = withIcon(
    () => import('./svg/icn_pds_success.svg?component'),
);
export const IcnPdsSwitch = withIcon(
    () => import('./svg/icn_pds_switch.svg?component'),
);
export const IcnPdsTag = withIcon(
    () => import('./svg/icn_pds_tag.svg?component'),
);
export const IcnPdsTheme = withIcon(
    () => import('./svg/icn_pds_theme.svg?component'),
);
export const IcnPdsTimeNormal = withIcon(
    () => import('./svg/icn_pds_time_normal.svg?component'),
);
export const IcnPdsTimeSolid = withIcon(
    () => import('./svg/icn_pds_time_solid.svg?component'),
);
export const IcnPdsTranslate = withIcon(
    () => import('./svg/icn_pds_translate.svg?component'),
);
export const IcnPdsTrash = withIcon(
    () => import('./svg/icn_pds_trash.svg?component'),
);
export const IcnPdsUp = withIcon(
    () => import('./svg/icn_pds_up.svg?component'),
);
export const IcnPdsUrgency = withIcon(
    () => import('./svg/icn_pds_urgency.svg?component'),
);
export const IcnPdsView = withIcon(
    () => import('./svg/icn_pds_view.svg?component'),
);
export const IcnPdsWalk = withIcon(
    () => import('./svg/icn_pds_walk.svg?component'),
);
export const IcnPdsWarning = withIcon(
    () => import('./svg/icn_pds_warning.svg?component'),
);
